import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import styles from "./../../../assets/scss/custom.module.scss";
import { FaSpinner } from "react-icons/fa";
import { LiaQuora } from "react-icons/lia";
import InvoiceComment from "../../../components/inv-comment-update/InvoiceComment";
import {
  downloadFileFromResponse,
  formatFTNumber,
  showAlert,
  showAlertWithHtml,
  showToast
} from "../../../utils/utils";
import privateAxios from "../../../utils/axiosPrivate";
import { Tooltip as ReactTooltip } from "react-tooltip";
import useGA4EventAction from "../../../config/GoogleAnalytics/useGA4EventAction";
import {
  InvoiceDetails,
  UserManagment,
  passwordConfirmModal,
  commentBox,
  fileDownloadMessages,
  tooltips,
  checklist,
  alertActions,
  updateStatusModalData,
  financeTab,
  userStatusAction,
  dashboard,
  commonErrMsg
} from "../../../locales/en";
import useMixpanelEventAction from "../../../config/mixpanel/useMixpanelEventAction";
import PasswordConfModal from "../../../components/modals/PasswordConfModal";
import AiCreditReportModal from "../../../components/modals/AiCreditReportModal";
import PropTypes from "prop-types";
import {
  FUNDED_STATUS_ID,
  PREVENT_BUTTON_CLICK,
  showToastType,
  STATUS_2,
  USER_STATUS_APPROVED
} from "../../../utils/constants/appConstants";
import {
  getAdvanceBankFileDownload,
  getCustomerInvoiceStatusApprovalData,
  getCustomerInvoiceStatusData,
  getPasswordConfirmation,
  setStatusInfo
} from "../../../redux/invoiceDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import CustomerStatusUpdateInfo from "../../../components/modals/CustomerStatusUpdateInfo";
import CustomerStatusUpdateApprovalInfo from "../../../components/modals/CustomerStatusUpdateApprovalInfo";
import {
  getBulkUpdateQuotesStatusUrl,
  getDownloadFundingNoticeUrl,
  getDownloadPOPRequiredURL,
  getPostQuotePDFUrl,
  getRiskAdvsrGenerateQuoteUrl,
  loanInvDownloadURL,
  loanInvUploadDocURL
} from "../../../utils/constants/apiEndPoints";
import InvoiceActions from "./InvoiceActions";
import { usePrventBtnClick } from "../../../hooks/usePrventBtnClick";
import { BiSolidFileDoc } from "react-icons/bi";

const Information = (props) => {
  const dispatch = useDispatch();
  const { customerStatusData, statusInfo, loadingBtn } = useSelector(
    (state) => state.invoiceDetails
  );
  const statusInfoData = customerStatusData || [];
  const { invData, fetchInvoiceData, quoteStatus } = props;
  const [InvDetails, setInvDetails] = useState({});
  const [grpStatus, setGrpStatus] = useState("");
  const [loadSpin, setLoadSpin] = useState(false);
  const { invoiceFullyFundedGA4Event, fileDownloadGA4Event } =
    useGA4EventAction();
  const userId = useSelector((state) => state?.userManagement?.profile?.id);
  const {
    approvedInvoiceMixpanelEvent,
    fundedInvoiceMixpanelEvent,
    rejectInvoiceMixpanelEvent
  } = useMixpanelEventAction();
  const fileInputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState();
  const [messageShow, setMessageShow] = useState(false);
  const { id } = useParams();
  const [addCreditScoreModal, setAddCreditScoreModal] = useState(false);
  const [generateType, setGenerateType] = useState(false);
  const [creditScoreData, setcreditScoreData] = useState({});
  const [userAccId, setUserAccId] = useState(null);
  const [enterPassword, setEnterPassword] = useState(false);
  const [updateApprovalinfo, setUpdateApprovalinfo] = useState(false);
  const [password, setPassword] = useState("");
  const [approvalData, setApprovalData] = useState({});
  const [statusNewValue, setStatusNewValue] = useState(null);
  const [daysDiffLength, setDaysDiffLength] = useState(null);
  const [passwordError, setPasswordError] = useState("");
  const [scoreLoading, setScoreLoading] = useState(false);
  const { isProcessing, isLocked, setIsProcessing } =
    usePrventBtnClick(PREVENT_BUTTON_CLICK);

  useEffect(() => {
    if (invData) {
      setInvDetails(invData);
      setGrpStatus(invData?.quoteStatus?.id);
      setUserAccId(invData?.userAccountId);
      setDaysDiffLength(invData?.daysDiffLength);
    }
  }, [invData]);

  const triggerFileUpload = () => fileInputRef.current?.click();

  const fileUpload = (e) => {
    setUploadedFile(e.target.files[0]);
    setMessageShow(!!e.target.files[0]);
  };

  // File Download
  const [quoteDownloadLoadingId, setQuoteDownloadLoadingId] = useState(false);
  const handleQuoteDownload = useCallback(async () => {
    if (isLocked()) return;
    try {
      setQuoteDownloadLoadingId(true);
      setIsProcessing(true);
      const invId = InvDetails?.invoice?.quoteId;
      if (!invId) {
        showToast(
          InvoiceDetails?.fundtapInformation?.errors?.invalidId,
          showToastType?.error
        );
        return;
      }
      const response = await privateAxios.post(getPostQuotePDFUrl(invId), [], {
        responseType: "blob"
      });
      if (!response.data || response.data.size === 0)
        throw new Error(`${InvoiceDetails?.fundtapInformation?.errors?.empty}`);
      let filename = "quote.pdf";
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+?)"/);
        if (match && match[1]) filename = match[1];
      }
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(link.href), 500);
      fileDownloadGA4Event(userId, filename);
      showToast(
        InvoiceDetails?.fundtapInformation?.errors?.successDownload,
        showToastType?.success
      );
    } catch (error) {
      showToast(
        error?.response?.data?.message ||
          fileDownloadMessages?.errors?.downloadFailed,
        showToastType?.error
      );
    } finally {
      setQuoteDownloadLoadingId(false);
      setIsProcessing(false);
    }
  }, [InvDetails, userId, fileDownloadGA4Event, isProcessing]);

  // File Download
  const handleGeneralNotice = async () => {
    if (isLocked()) return;
    setIsProcessing(true);
    try {
      const quoteId = InvDetails?.id;
      if (!quoteId) {
        showToast(
          InvoiceDetails?.fundtapInformation?.errors?.invalidId,
          showToastType?.error
        );
        return;
      }

      const response = await privateAxios.get(
        getDownloadFundingNoticeUrl(quoteId),
        { responseType: "blob" }
      );

      // Extract filename from content-disposition header
      let filename = "funding-notice.pdf";
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+?)"/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element and trigger download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Revoke URL after a short delay to ensure download starts
      setTimeout(() => URL.revokeObjectURL(link.href), 500);

      // Track download event
      fileDownloadGA4Event(userId, filename);

      showToast(
        InvoiceDetails?.fundtapInformation?.errors?.successDownload,
        showToastType?.success
      );
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        fileDownloadMessages?.errors?.downloadFailed;
      showToast(errorMessage, showToastType?.error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleInvoiceUpload = async () => {
    const invoiceFile = uploadedFile;
    const invoiceId = InvDetails?.invoiceId;

    if (invoiceFile && invoiceId) {
      if (isLocked()) return;
      setIsProcessing(true);
      try {
        const formData = new FormData();
        formData.append("file", invoiceFile);

        const response = await privateAxios.put(
          loanInvUploadDocURL(invoiceId),
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        showToast(response.data.message, showToastType?.success);
        setMessageShow(false);
        // Refresh parent data so Details gets updated invData
        if (typeof fetchInvoiceData === "function") {
          await fetchInvoiceData();
        }
      } catch (error) {
        showToast(
          error.response?.data?.message ||
            fileDownloadMessages?.errors?.uploadFaield,
          showToastType?.error
        );
      } finally {
        setIsProcessing(false);
      }
    }
  };

  const [popDownloadLoading, setPopDownloadLoading] = useState(false);
  const handlePOPDownload = async () => {
    if (isLocked()) return;
    try {
      setPopDownloadLoading(true);
      setIsProcessing(true);
      const response = await privateAxios.get(getDownloadPOPRequiredURL(id), {
        responseType: "blob"
      });
      downloadFileFromResponse(response);
      showToast(checklist?.errors.fileDownload, showToastType?.success);
    } catch (error) {
      showToast(
        error?.response?.data?.message ||
          fileDownloadMessages?.errors?.downloadFailed,
        showToastType?.error
      );
    } finally {
      setPopDownloadLoading(false);
      setIsProcessing(false);
    }
  };

  const handlePendingDownload = async () => {
    if (isLocked()) return;
    try {
      setLoadSpin(true);
      setIsProcessing(true);
      const response = await privateAxios.get(loanInvDownloadURL, {
        params: { invoiceId: InvDetails?.invoiceId },
        responseType: "blob"
      });
      downloadFileFromResponse(response);
      showToast(checklist?.errors.fileDownload, showToastType?.success);
    } catch (error) {
      if (error.response?.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorJson = JSON.parse(errorText);
          showToast(
            errorJson.message || errorJson.errors?.[0] || commonErrMsg.item11,
            showToastType.error
          );
        } catch (error) {
          let errorMsg = commonErrMsg.item11;
          if (error.response?.data instanceof Blob) {
            errorMsg = commonErrMsg.item11;
          } else {
            errorMsg =
              error.response?.data?.message ||
              error.response?.data?.errors?.[0] ||
              commonErrMsg.item11;
          }

          showToast(errorMsg, showToastType.error);
        }
      }
    } finally {
      setLoadSpin(false);
      setIsProcessing(false);
    }
  };

  // Group Status Change
  const getStatusNameById = useCallback(
    (id) => {
      return (
        quoteStatus?.find((statusObj) => statusObj.id === Number(id))?.status ||
        id
      );
    },
    [quoteStatus]
  );

  const handleGroupStatusChange = async (event) => {
    const { value } = event.target;
    const selectedValue = value.toString();
    const hasNonApprovedStatus = invData?.userStatusId !== USER_STATUS_APPROVED;
    setStatusNewValue(selectedValue);

    const oldStatusName = getStatusNameById(grpStatus);
    const newStatusName = getStatusNameById(selectedValue);
    const secondConfirm = await showAlert(
      `${formatFTNumber(InvDetails?.fmfbFundQuotesId)} ${updateStatusModalData.sub2}`,
      `${updateStatusModalData?.stattus} ${oldStatusName} ${financeTab?.funding?.creditLimitHistModal?.to} ${newStatusName}`,
      alertActions?.warning,
      alertActions?.Confirm,
      alertActions?.Cancel
    );

    if (secondConfirm.isConfirmed) {
      if (hasNonApprovedStatus && value === STATUS_2) {
        const secondResult = await showAlert(
          dashboard?.advanceAlert?.subTitle_1,
          dashboard?.advanceAlert?.message_1,
          alertActions?.warning,
          UserManagment?.ownerTab?.identificationSection
            ?.isApplyIdMandatoryStatus?.true,
          alertActions?.Cancel
        );

        if (secondResult?.isDismissed || !secondResult.isConfirmed) {
          setGrpStatus("");
          return;
        }
      } else if (selectedValue === STATUS_2) {
        handleStatusErrorGet();
      } else {
        setGrpStatus(selectedValue);
        handleGroupStatusUpdate(selectedValue);
      }
    }
  };

  const handleGroupStatusUpdate = async (newValue) => {
    try {
      const statusId = newValue;
      const dataToSend = {
        quoteIds: [InvDetails?.id],
        statusId: statusId
      };

      const response = await privateAxios.put(
        getBulkUpdateQuotesStatusUrl,
        dataToSend
      );

      if (response.status === 200) {
        if (statusId === "2") {
          //Approved
          const approvedInvoices =
            response?.data?.data?.approvedQuoteList ?? [];
          if (approvedInvoices.length > 0) {
            approvedInvoiceMixpanelEvent(approvedInvoices);
          }
        } else if (statusId === "4") {
          //Funded
          const fundedInvoices = response?.data?.data?.fundedQuoteList ?? [];
          if (fundedInvoices.length > 0) {
            fundedInvoiceMixpanelEvent(fundedInvoices);
            invoiceFullyFundedGA4Event(
              invData?.userAccountId,
              invData?.invoiceId,
              invData?.fundingAmount
            );
          }
        } else if (statusId === "5") {
          const rejectInvoices = response?.data?.data?.rejectedQuoteList || [];
          if (rejectInvoices.length > 0) {
            rejectInvoiceMixpanelEvent(rejectInvoices);
          }
        }

        showToast(response.data.message, showToastType?.success);
        fetchInvoiceData();
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        showToast(error.response.data.message, showToastType?.error);
      } else {
        showToast(error?.message, showToastType?.error);
      }
    }
  };

  const fetchCreditScoreData = async (generateTypeValue) => {
    try {
      if (generateTypeValue) setScoreLoading(true);
      const response = await privateAxios.post(
        getRiskAdvsrGenerateQuoteUrl(id),
        {},
        {
          params: {
            userAccountId: userAccId,
            generateType: generateTypeValue || false
          }
        }
      );
      if (response.status === 200) {
        setcreditScoreData(response.data.data);
        if (generateTypeValue === true) {
          setAddCreditScoreModal(true);
        }
      }
    } catch (error) {
      showToast(error.response?.data?.message, showToastType.error);
    } finally {
      if (generateTypeValue) setScoreLoading(false);
    }
  };

  const toggleAiCreditmodal = () => {
    setAddCreditScoreModal(!addCreditScoreModal);
  };

  const handleStatusErrorGet = async () => {
    try {
      const response = await dispatch(
        getCustomerInvoiceStatusData({ id })
      ).unwrap();
      if (response.status === 200 || response.status === 201) {
        if (daysDiffLength > 60) {
          const messageHtml = `
            <ul style="text-align: left; text-align: center;">
              <li>${InvoiceDetails?.invoceStausChange?.content1}</li>
              <li></li>
              <li><strong>${formatFTNumber(InvDetails?.fmfbFundQuotesId)}</strong> ${InvoiceDetails?.invoceStausChange?.content2} <strong>${daysDiffLength}</strong> ${InvoiceDetails?.invoceStausChange?.content3}</li>
              <li></li>
            </ul>
            <p>${userStatusAction?.subH2}</p>
          `;

          const statusChange = await showAlertWithHtml(
            userStatusAction?.title,
            messageHtml,
            alertActions?.warning,
            alertActions?.Confirm,
            alertActions?.Cancel
          );

          if (statusChange.isConfirmed) {
            handleUpdateApprovalStatus();
          }
        } else {
          handleUpdateApprovalStatus();
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        showToast(error.response.data.message, showToastType?.error);
      }
    }
  };

  const handleUpdateApprovalStatus = async () => {
    try {
      const payload = {
        quoteIds: [Number(id)]
      };
      const response = await dispatch(
        getCustomerInvoiceStatusApprovalData(payload)
      ).unwrap();
      const responseData = response.data.data;
      if (response.status === 200 && responseData?.status === false) {
        handleGroupStatusUpdate(STATUS_2);
      } else if (response.status === 200 && responseData?.status === true) {
        setApprovalData(response.data.data);
        setUpdateApprovalinfo(true);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        showToast(error.response.data.message, showToastType?.error);
      }
    }
  };

  // for password submit
  const handlePasswordSubmit = async () => {
    if (!password?.trim()) {
      setPasswordError(passwordConfirmModal?.passwordRequired);
      return;
    }
    setPasswordError("");
    try {
      const dataToSend = { password };
      const response = await dispatch(
        getPasswordConfirmation(dataToSend)
      ).unwrap();

      if (response.status === 200 || response.status === 201) {
        setEnterPassword(false);
        dispatch(setStatusInfo(false));
        setPassword("");
        if (statusNewValue !== null) {
          if (daysDiffLength > 60) {
            const messageHtml = `
            <ul style="text-align: left; text-align: center;">
              <li>${InvoiceDetails?.invoceStausChange?.content1}</li>
              <li></li>
              <li><strong>${formatFTNumber(InvDetails?.fmfbFundQuotesId)}</strong> ${InvoiceDetails?.invoceStausChange?.content2} <strong>${daysDiffLength}</strong> ${InvoiceDetails?.invoceStausChange?.content3}</li>
              <li></li>
            </ul>
            <p>${userStatusAction?.subH2}</p>
          `;
            const statusChange = await showAlertWithHtml(
              userStatusAction?.title,
              messageHtml,
              alertActions?.warning,
              alertActions?.Confirm,
              alertActions?.Cancel
            );

            if (statusChange.isConfirmed) {
              handleUpdateApprovalStatus();
            }
          } else {
            handleUpdateApprovalStatus();
          }
        } else {
          setGenerateType(true);
          fetchCreditScoreData(true);
        }
      } else {
        showToast(
          passwordConfirmModal?.validationMessage,
          showToastType?.error
        );
      }
    } catch {
      // handle catch here;
    }
  };

  const handleRefreshData = () => {
    setEnterPassword(true);
  };

  const handleApprovalStatusUpdate = () => {
    setUpdateApprovalinfo(!updateApprovalinfo);
  };

  const handleDownloadBankDocument = async () => {
    if (isLocked()) return;
    setIsProcessing(true);
    try {
      const response = await dispatch(
        getAdvanceBankFileDownload({ id })
      ).unwrap();

      let filename = `Quote_advance_${InvDetails?.id}`;
      const fileType = response.headers["content-type"];
      const blob = new Blob([response.data], { type: fileType });

      if (fileType === "application/pdf") {
        filename = filename.endsWith(".pdf") ? filename : `${filename}.pdf`;
      } else if (fileType === "image/jpeg") {
        filename = filename.endsWith(".jpg") ? filename : `${filename}.jpg`;
      } else if (fileType === "image/png") {
        filename = filename.endsWith(".png") ? filename : `${filename}.png`;
      } else if (fileType === "application/zip") {
        filename = filename.endsWith(".zip") ? filename : `${filename}.zip`;
      } else if (
        fileType === "text/csv" ||
        fileType === "application/vnd.ms-excel"
      ) {
        filename = filename.endsWith(".csv") ? filename : `${filename}.csv`;
      } else if (fileType === "text/plain") {
        filename = filename.endsWith(".aba") ? filename : `${filename}.aba`;
      } else {
        filename = filename.endsWith(".bin") ? filename : `${filename}.bin`;
      }

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      // handle catch here;
    } finally {
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    if (invData && invData?.userAccountId && userAccId) {
      fetchCreditScoreData(generateType);
    }
  }, [userAccId, invData]);

  const handleToggleStatusInfo = () => {
    dispatch(setStatusInfo(false));
    setPassword("");
  };

  const tooltipsList = [
    { id: "tooltip-pop", place: "bottom", content: tooltips?.popdoc },
    { id: "tooltip-quote", place: "bottom", content: tooltips?.quote },
    {
      id: "tooltip-download",
      place: "bottom",
      content: tooltips?.downloadInvoice
    },
    {
      id: "tooltip-search-creditScore",
      place: "bottom",
      content: tooltips?.searchCreditScore
    },
    { id: "tooltip-viewUser", place: "top", content: tooltips?.invoiceCopy },
    {
      id: "tooltip-upload",
      place: "top",
      content: tooltips?.uploadInvoiceCopy
    },
    { id: "tooltip-message", place: "top", content: tooltips?.submitInvoice },
    { id: "tooltip-notice", place: "top", content: tooltips?.fundingNotice },
    {
      id: "tooltip-bank-quote",
      place: "top",
      content: `${InvoiceDetails?.paymentSection?.typeCmntProp}`
    }
  ];
  const handlePasswordChange = (val) => {
    setPassword(val);
    setPasswordError((prev) => (prev ? "" : prev));
  };
  const passwordModalCommonProps = {
    onSubmit: handlePasswordSubmit,
    password,
    setPassword: handlePasswordChange,
    errorMessage: passwordError
  };
  return (
    <>
      <div className={styles.titleArea}>
        <h5>{InvoiceDetails?.fundtapInformation?.title}</h5>
      </div>

      <div className="row">
        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom`}>
              <h5>{InvoiceDetails?.fundtapInformation?.ftNo}</h5>
            </div>
            <div className={`d-flex align-items-center ${styles.ftNumberWrap}`}>
              <span>{formatFTNumber(InvDetails?.invoice?.quoteId)}</span>
              {InvDetails?.batchQuoteId &&
                String(InvDetails.batchQuoteId) !==
                  String(InvDetails?.invoice?.quoteId) && (
                  <span>({formatFTNumber(InvDetails?.batchQuoteId)})</span>
                )}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle}`}>
              <h5>{InvoiceDetails?.fundtapInformation?.status}</h5>
            </div>
            <select
              className={styles.selectdropdown}
              value={grpStatus}
              onChange={handleGroupStatusChange}
            >
              {quoteStatus.map((status) => (
                <option
                  key={status.id}
                  value={status.id}
                  disabled={status.id === FUNDED_STATUS_ID}
                >
                  {status.status}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom`}>
              <h5>{InvoiceDetails?.fundtapInformation?.documents}</h5>
            </div>
            <ul
              className={`${styles.btngroupwrap} d-flex justify-content-end align-items-center`}
            >
              {InvDetails?.popDocuments && (
                <li>
                  <button
                    type="button"
                    className={styles.btnPrimary}
                    data-tooltip-id="tooltip-pop"
                    onClick={handlePOPDownload}
                    disabled={popDownloadLoading}
                  >
                    {popDownloadLoading ? (
                      <FaSpinner className="spin-load" />
                    ) : (
                      <BiSolidFileDoc />
                    )}
                  </button>
                </li>
              )}
              <li>
                <span className={`${styles.btnPrimary} office-icon added-icon`}>
                  {loadingBtn ? (
                    <span className="loadSpin">
                      <FaSpinner />
                    </span>
                  ) : (
                    <Link
                      onClick={handleDownloadBankDocument}
                      data-tooltip-id="tooltip-bank-quote"
                      style={
                        isProcessing
                          ? { pointerEvents: "none", opacity: 0.6 }
                          : {}
                      }
                    >
                      <span className={styles.btnPrimary}>
                        <input type="button" disabled={isProcessing} />
                      </span>
                    </Link>
                  )}
                </span>
              </li>
              <li>
                <button
                  type="button"
                  className={styles.btnPrimary}
                  data-tooltip-id="tooltip-quote"
                  onClick={handleQuoteDownload}
                  disabled={quoteDownloadLoadingId}
                >
                  {quoteDownloadLoadingId ? (
                    <FaSpinner className="spin-load" />
                  ) : (
                    <LiaQuora />
                  )}
                </button>
              </li>

              {[4, 11, 9].includes(grpStatus) && (
                <li className="tooltipNotice">
                  <Link
                    onClick={handleGeneralNotice}
                    data-tooltip-id="tooltip-notice"
                    style={
                      isProcessing
                        ? { pointerEvents: "none", opacity: 0.6 }
                        : {}
                    }
                  >
                    <span className={styles.btnPrimary}>
                      <input type="button" value="FN" disabled={isProcessing} />
                    </span>
                  </Link>
                </li>
              )}

              <InvoiceActions
                InvDetails={InvDetails}
                InvoiceDetails={InvoiceDetails}
                loadSpin={loadSpin}
                triggerFileUpload={triggerFileUpload}
                fileUpload={fileUpload}
                fileInputRef={fileInputRef}
                messageShow={messageShow}
                handleInvoiceUpload={handleInvoiceUpload}
                handlePendingDownload={handlePendingDownload}
              />
            </ul>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-8 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom`}>
              <h5>{InvoiceDetails?.fundtapInformation?.overduePredict}</h5>
            </div>
            <div
              className={`${styles.linkwrap} d-flex justify-content-between`}
            >
              <Link to="#" onClick={toggleAiCreditmodal}>
                {creditScoreData?.overdueOutput}
              </Link>

              <ul
                className={`${styles.btngroupwrap} d-flex justify-content-end align-items-center`}
              >
                <li>
                  <span
                    className={`${styles.btnPrimary} scoresearch-icon added-icon`}
                  >
                    {scoreLoading ? (
                      <span className="loadSpin">
                        <FaSpinner className="spin-load" />
                      </span>
                    ) : (
                      <input
                        type="button"
                        onClick={handleRefreshData}
                        data-tooltip-id="tooltip-search-creditScore"
                      />
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom`}>
              <h5>{InvoiceDetails?.fundtapInformation?.alerts}</h5>
            </div>
            <p>{invData.alerts}</p>
          </div>
        </div>
        <div className="col-12 mb-3">
          <div className="blog-input-wrap">
            <InvoiceComment
              fetchInvoiceData={fetchInvoiceData}
              invData={invData}
              titleText={InvoiceDetails?.fundtapInformation?.comment}
              sureDeleteMsg={commentBox?.commentDeleteMsg}
              addText={commentBox?.commentAddText}
              placeholder={commentBox?.commentPlaceholderText}
              addBtnText={commentBox?.commentAddBtnText}
              responseMsg={commentBox?.commentAddText}
            />
          </div>
        </div>
      </div>
      <AiCreditReportModal
        isOpen={addCreditScoreModal}
        toggle={toggleAiCreditmodal}
        creditScoreData={creditScoreData}
      />
      <PasswordConfModal
        title={
          UserManagment?.financialsTab?.aiCreditScoreSection?.passwordModal
            ?.title
        }
        content={
          UserManagment?.financialsTab?.aiCreditScoreSection?.passwordModal
            ?.subTitle
        }
        isOpen={enterPassword}
        onClose={() => setEnterPassword(false)}
        {...passwordModalCommonProps}
      />

      {statusInfo && (
        <CustomerStatusUpdateInfo
          isOpen={statusInfo}
          toggle={handleToggleStatusInfo}
          errorData={statusInfoData}
          content={
            UserManagment?.financialsTab?.aiCreditScoreSection?.passwordModal
              ?.subTitle
          }
          {...passwordModalCommonProps}
        />
      )}

      <CustomerStatusUpdateApprovalInfo
        isOpen={updateApprovalinfo}
        toggle={handleApprovalStatusUpdate}
        approvalData={approvalData}
        handleGroupStatusUpdate={handleGroupStatusUpdate}
      />

      {tooltipsList.map(({ id, place, content }) => (
        <ReactTooltip
          key={id}
          className="tooltipcustom"
          id={id}
          place={place}
          content={content}
        />
      ))}
    </>
  );
};

Information.propTypes = {
  invData: PropTypes.object,
  fetchInvoiceData: PropTypes.func.isRequired,
  quoteStatus: PropTypes.array.isRequired
};

export default Information;
